@import "../../packages/shared/scss";

$bounce-duration: 2s;
$bounce-distance: 4px;

@mixin max-width-more-content($level) {
  @if $level == "l2" {
    max-inline-size: calc(
      #{$max-model-width-mobile-l2} + 2 * #{$pds-spacing-static-medium}
    );

    @include pds-media-query-min("s") {
      max-inline-size: calc(
        #{$max-model-width-desktop-l2} - 2 * #{$pds-spacing-static-medium}
      );
    }
  }

  @if $level == "l3" {
    max-inline-size: calc(
      #{$max-model-width-mobile-l3} + 2 * #{$pds-spacing-static-medium}
    );

    @include pds-media-query-min("s") {
      max-inline-size: calc(
        #{$max-model-width-desktop-l3} - 2 * #{$pds-spacing-static-medium}
      );
    }
  }
}

// Pcom => PcomScrollIndicator__scrollIndicatorMoving (width adjustments)
@keyframes bounce {
  20%,
  50%,
  80%,
  to {
    transform: translateY($bounce-distance);
  }

  0%,
  40%,
  60%,
  100% {
    transform: translateY(0);
  }
}

@keyframes bottom-in {
  to {
    translate: 0 0;
  }
}

@keyframes bottom-out {
  from {
    translate: 0 0;
  }
  to {
    translate: 0 calc(100% + 1rem);
  }
}

:host {
  .more-indicator-container {
    box-sizing: border-box;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    inset-inline-start: 0;
    inset-inline-end: 0;

    @supports (height: 100dvh) {
      // Account for mobile nav bars at the bottom
      inset-block-start: calc(100dvh - 4.5rem);
    }

    @supports not (height: 100dvh) {
      // fallback button might be eventually hidden
      inset-block-end: 1rem;
    }

    padding-block: 0;
    padding-inline: 1rem;
    translate: 0 calc(100% + 1rem);
    animation: bottom-in $pds-motion-duration-short $pds-motion-easing-in 1.5s
      forwards;

    &.bottom-out {
      animation: bottom-out $pds-motion-duration-short $pds-motion-easing-in
        forwards;
    }

    @include pds-media-query-min("s") {
      inset-inline-start: 50%;
    }
  }

  .more-indicator-button {
    &.btn-l2 {
      @include max-width-more-content("l2");
    }

    &.btn-l3 {
      @include max-width-more-content("l3");
    }

    inline-size: 100%;
    @include pds-media-query-min("s") {
      inline-size: calc(100% - 2 * $pds-spacing-static-medium);
    }

    padding-block: $pds-spacing-static-medium !important; // prevent from beeing overridden by stencil
    padding-inline: $pds-spacing-static-medium !important; // prevent from beeing overridden by stencil

    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 0 400px 0 rgba($pds-theme-light-contrast-medium, 0.0824);
    background: rgba($pds-theme-light-background-frosted, 0.4392);
    cursor: pointer;
    border: none;
    border-radius: $pds-border-radius-small;
    color: $pds-theme-light-primary;

    @include pds-text-small();
    @include pds-frosted-glass();
    @include pds-hover;

    &:hover {
      .bounce {
        animation-name: bounce, bounce;
        animation-iteration-count: 1, 1;
      }
    }

    span {
      margin-inline-start: $pds-spacing-static-x-small;
    }

    .bounce {
      animation-name: bounce;
      animation-duration: $bounce-duration;
      animation-timing-function: $pds-motion-easing-base;
      animation-iteration-count: 1;
    }
  }
}
